import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import publicProfileService from './publicProfileService'

const initialState = {
    profile: undefined,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
}

export const getPublicProfile = createAsyncThunk('publicProfile/getPublicProfile', async (profileData, { getState, rejectWithValue }) => {
    try {
        return await publicProfileService.getPublicProfile(profileData);
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString());
    }
})

export const publicProfileSlice = createSlice({
    name: 'publicProfile',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPublicProfile.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(getPublicProfile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.profile = action.payload.profile
            })
            .addCase(getPublicProfile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.payload
            })
    }
})

export const { reset } = publicProfileSlice.actions
export default publicProfileSlice.reducer